import React from 'react';

const Logo = (props) => {
  return (
    <img
      style={{width:"60px"}}
      alt="Logo"
      src="/static/animaelogo.png"
      {...props}
    />
  );
};

export default Logo;
